import type { SpmModuleCodes } from './types';

/** 普通坑位查表；试戴及移动端列表商品/收藏按已登记模板连续编号。 */
export function resolveSpmPositionCode(
  moduleCodes: SpmModuleCodes | undefined,
  position: string,
): string | undefined {
  if (!moduleCodes) return undefined;

  const dynamicPosition = /^(product|favorite|try_on)_(\d+)$/.exec(position);
  const isMobileProductList = /^[^.]+\.product_list_(wap|app)\.product_results$/.test(
    moduleCodes.code,
  );
  const kind = dynamicPosition?.[1];
  const positionTemplate = kind ? moduleCodes[`${kind}_001`] : undefined;
  if (dynamicPosition && positionTemplate && (kind === 'try_on' || isMobileProductList)) {
    const template = new RegExp(`^(.*\\.${kind}_)(\\d+)$`).exec(positionTemplate);
    const index = Number(dynamicPosition[2]);
    const ordinal = template ? Number(template[2]) + index - 1 : NaN;
    if (
      !template ||
      !Number.isSafeInteger(index) ||
      index < 1 ||
      !Number.isSafeInteger(ordinal) ||
      ordinal < 1
    ) {
      return undefined;
    }
    return `${template[1]}${String(ordinal).padStart(3, '0')}`;
  }

  const value = moduleCodes[position];
  return typeof value === 'string' && value ? value : undefined;
}
